// src/components/Configuration.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import useConfiguration from "../../hooks/configuration/useConfiguration";
import Breadcrumb from "../../components/Breadcrumb";
const Configuration = () => {
  const {
    configs,
    loading,
    savingKey,
    error,
    handleChange,
    handleSave,
    refreshConfigurations,
  } = useConfiguration();

  if (loading) return <p>Loading configurations...</p>;
  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Settings" child="All Settings" />
        {error && <div className="alert alert-danger">{error}</div>}
        <button
          className="btn btn-primary"
          onClick={() => refreshConfigurations()}
        >
          Refresh
        </button>
        <div className="table-responsive border rounded m-2 p-3">
          <table className="table  table-hover">
            <thead className="">
              <tr>
                <th colspan={5}>Settings</th>
              </tr>
            </thead>
            <tbody>
              {configs.map((config) => (
                <tr key={config.configKey}>
                  <td>
                    <h6>{config.configDisplayName}</h6>
                    <p> {config.definition}</p>
                  </td>
                  <td>
                    {config.configType === "boolean" ? (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={config.configValue === "true"}
                        onChange={(e) =>
                          handleChange(
                            config.configKey,
                            e.target.checked.toString(),
                          )
                        }
                      />
                    ) : (
                      <input
                        type={
                          config.configType === "number"
                            ? "number"
                            : config.configType === "color"
                              ? "color"
                              : config.configType === "textArea"
                                ? "textarea"
                                : "text"
                        }
                        className={`form-control color-input`}
                        value={config.configValue || ""}
                        onChange={(e) =>
                          handleChange(config.configKey, e.target.value)
                        }
                      />
                    )}
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="btn btn-primary" onClick={() => handleSave()}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Configuration;
